export enum Gender {
    Male = "Male",
    Female = "Female",
    Others = "Transgender",
}
